import { Loader } from '@mantine/core';

const CustomLoader = () => <Loader color="var(--primary-green)" />;

export default CustomLoader;
